<template>
  <div class="userTabContainer">
    <PasswordManagerUsersItemList
      class="passwordManagerUsersItemList"
      :excludedColumns="excludedColumns"
      @showGroupModal="handleShowGroupModal"
    />
  </div>
</template>

<script>
import { columns as passwordManagerUsersItemListColumns } from 'client/PasswordManager/Users/PasswordManagerUsersItemListColumns';
import PasswordManagerUsersItemList from 'client/PasswordManager/Users/PasswordManagerUsersItemList.vue';

export default {
  name: 'PasswordManagerUsers',

  components: {
    PasswordManagerUsersItemList,
  },

  computed: {
    excludedColumns() {
      return [passwordManagerUsersItemListColumns.oldPasswords,
        passwordManagerUsersItemListColumns.weakPasswords];
    },
  },

  methods: {
    handleShowGroupModal() {
      this.$emit('showGroupModal');
    },
  },
};
</script>

<style scoped>
  .userTabContainer {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .passwordManagerUsersItemList {
    flex: 1;
  }
</style>
